import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

/**
 * @deprecated Use the Row component from OPL (/OPL/Grid/Row.ts)
 * thanks <3
 */
export default Row;
